import { combineReducers } from "@reduxjs/toolkit";
import usersReducer from "./Slice";
import LoaderReducer from "./Loader";
const rootReducer = combineReducers({
  Loader: LoaderReducer,
  SideBarActive: usersReducer.SideBarActive,
  users: usersReducer.userReducer,
  forgotUsers: usersReducer.userForgotReducer,
  verifyOtpUser: usersReducer.userVerifyOtpReducer,
  resetPasswordUser: usersReducer.resetPasswordReducer,
  fetchPlant: usersReducer.fetchPlantReducer,
  fetchClient: usersReducer.fetchClientReducer,
  fetchFile: usersReducer.fetchFileReducer,
  createPlant: usersReducer.createPlantReducer,
  createProject: usersReducer.createProjectReducer,
  fetchProjectWbs: usersReducer.fetchProjectWbsReducer,
  createProjectWbs: usersReducer.createProjectWbsReducer,
  updateProjectWbs: usersReducer.updateProjectWbsReducer,
  updatePlant: usersReducer.updatePlantReducer,
  updateProject: usersReducer.updateProjectReducer,
  createSchedule: usersReducer.createScheduleReducer,
  RetrieveInvoiceData: usersReducer.RetrieveInvoiceReducer,
  RetrieveScheduledInvoiceData: usersReducer.RetrieveScheduledInvoiceReducer,
  plantListgetdropdata: usersReducer.plantListgetdropReducer,
  projectListgetdropdata: usersReducer.projectListgetdropReducer,
  projectwbsListgetdropdata: usersReducer.projectwbsListgetdropReducer,
  UserGetData: usersReducer.UserGetReduer,
  UserPostData: usersReducer.UserPostReduer,
  UserPutData: usersReducer.UserPutReduer,
  CommonPostData: usersReducer.CommonPostReduer,
  graphListRetrieveData: usersReducer.graphListRetrieveReducer,
});
export default rootReducer;
